<template>
  <EventsCoursesListWithFiltersWrapper
    :title="$t('events.upcoming_courses')"
    :event-type="EventType.Course"
    :list-type="
      authStore.auth ? EventsListTypeMap.MeUpcoming : EventsListTypeMap.Upcoming
    "
  >
    <template #empty>
      <div class="py-4">
        <template v-if="eventsStore.filtersCount > 0">
          {{ $t('events.no_courses_with_filters') }}
        </template>
        <template v-else>
          {{ $t('events.no_courses') }}
        </template>
      </div>
    </template>
  </EventsCoursesListWithFiltersWrapper>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useAuth } from '~/stores/auth'
import { useEvents } from '~/stores/events'
import { EventType, EventsListTypeMap } from '~/models/events'

const authStore = useAuth()
const eventsStore = useEvents()

const { t } = useI18n()

useHeadMeta({
  title: () => t('head_meta.academy_title'),
  description: () => t('head_meta.academy_description'),
  keywords: () => t('head_meta.academy_keywords'),
  image: 'https://cdn.wnhub.io/49201/66f6ac1e474f29.15759661.jpg',
})
</script>
